// useIsMobile.ts
import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint: number = 767): boolean => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint);
        };

        // Adiciona um ouvinte de evento ao objeto window para monitorar as alterações no tamanho da tela
        window.addEventListener('resize', handleResize);

        // Retorna uma função de limpeza para remover o ouvinte de evento
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpoint]);  // O hook será reexecutado se o breakpoint mudar

    return isMobile;
};

export default useIsMobile;
